// extracted by mini-css-extract-plugin
export var background = "styles-module--background--9efb9";
export var bodyRowMobile = "styles-module--bodyRowMobile--3952a";
export var columnHeading = "styles-module--columnHeading--81b60";
export var container = "styles-module--container--e948b";
export var cta = "styles-module--cta--2204a";
export var description = "styles-module--description--2b55e";
export var desktop = "styles-module--desktop--62a68";
export var disclaimerContent = "styles-module--disclaimerContent--47fe0";
export var disclaimerTitle = "styles-module--disclaimerTitle--7816c";
export var disclaimerTitleAndIcon = "styles-module--disclaimerTitleAndIcon--47e9b";
export var feature = "styles-module--feature--60297";
export var footer = "styles-module--footer--25c08";
export var header = "styles-module--header--27c2c";
export var icon = "styles-module--icon--e74e0";
export var iconContainer = "styles-module--iconContainer--74ffa";
export var infoButton = "styles-module--infoButton--56b0c";
export var infoIcon = "styles-module--infoIcon--ea01d";
export var logo = "styles-module--logo--45420";
export var priceCircle = "styles-module--priceCircle--c5a61";
export var section = "styles-module--section--e15df";
export var table = "styles-module--table--0f30c";
export var tableCell = "styles-module--tableCell--20b0c";
export var tableCellHeading = "styles-module--tableCellHeading--4cd10";
export var tableHeading = "styles-module--tableHeading--9a06e";
export var tableHeadingContainer = "styles-module--tableHeadingContainer--bbc9f";
export var title = "styles-module--title--4e413";
export var visible = "styles-module--visible--2dcb4";